var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00002 4.99992C4.54169 4.99992 4.16669 4.62492 4.16669 4.16659C4.16669 3.70825 4.54169 3.33325 5.00002 3.33325C5.45835 3.33325 5.83335 3.70825 5.83335 4.16659C5.83335 4.62492 5.45835 4.99992 5.00002 4.99992ZM7.50002 4.24992C7.50002 2.73742 6.39585 1.66659 5.00002 1.66659C3.60419 1.66659 2.50002 2.73742 2.50002 4.24992C2.50002 5.22492 3.31252 6.51659 5.00002 8.05825C6.68752 6.51659 7.50002 5.22492 7.50002 4.24992ZM5.00002 0.833252C6.75002 0.833252 8.33335 2.17492 8.33335 4.24992C8.33335 5.63325 7.22085 7.27075 5.00002 9.16659C2.77919 7.27075 1.66669 5.63325 1.66669 4.24992C1.66669 2.17492 3.25002 0.833252 5.00002 0.833252Z",
    fill: "#938F96"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c02db1ca.svg";
export { ForwardRef as ReactComponent };